var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-head-transition pa-0 my-0 mx-auto",class:_vm.transitionPosition,style:(_vm.getStyle)},[_c('img',{staticClass:"page-head-transition__sizer",attrs:{"src":_vm.$appConfig.appTransitionOpen,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }